import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Typography,
  Checkbox,
  Autocomplete,
  Button,
  RadioGroup,
  Radio,
} from "@mui/material";
import { getAllVendorType } from "../../../api/ap_services";
import SectionCard from "./SectionCard";
import { makeStyles } from "@mui/styles";

const categoryOptions = [
  { value: "Private Limited", label: "Private Limited" },
  { value: "Partnership", label: "Partnership" },
  { value: "Limited Liability", label: "Limited Liability" },
  { value: "Public Listed", label: "Public Listed" },
  { value: "Proprietorship", label: "Proprietorship" },
  { value: "Other", label: "Other" },
];

const useStyles = makeStyles((theme) => ({
  customAutocompleteInput: {
    "& .MuiInputBase-sizeSmall": {
      height: "40px" /* Adjust the height as needed */,
    },
  },
}));
const Step1CompanyDetails = ({
  formData,
  onFieldChange,
  errors,
  touched,
  setFieldValue,
  onOwnerContactBlur,
  groupId,
  isEdit,
  isVendorUser = false,
}) => {
  const fieldError = (name) => Boolean(touched?.[name] && errors?.[name]);
  const fieldHelper = (name) => (touched?.[name] && errors?.[name]) || "";
  const fieldsEnabled = Boolean(groupId?.isAdmin);

  const classes = useStyles();

  // const shareholdingStatusValue = Array.isArray(formData.shareholdingStatus)
  //   ? formData.shareholdingStatus
  //   : formData.shareholdingStatus
  //     ? [formData.shareholdingStatus]
  //     : [];
  // const handleShareholdingStatusChange = (value) => {
  //   if (!setFieldValue) return;
  //   const next = shareholdingStatusValue.includes(value)
  //     ? shareholdingStatusValue.filter((v) => v !== value)
  //     : [...shareholdingStatusValue, value];
  //   setFieldValue("shareholdingStatus", next);
  // };

  // const isShareholdingStatusOtherSelected =
  //   shareholdingStatusValue.includes("Other");

  const shareholdingStatusValue = Array.isArray(formData.shareholdingStatus)
    ? formData.shareholdingStatus[0] || ""
    : formData.shareholdingStatus || "";

const handleShareholdingStatusChange = (value) => {
  setFieldValue?.("shareholdingStatus", value);
};

const isShareholdingStatusOtherSelected =
  shareholdingStatusValue === "Other";

  const [vendorComboOptions, setVendorComboOptions] = useState([]);
  useEffect(() => {
    getAllVendorType(0, 9999).then((res) => {
      const list = res?.response?.responseObject ?? [];
      setVendorComboOptions(Array.isArray(list) ? list : []);
    });
  }, []);

  // In edit mode: when options load and we have vendorTypeId from API, set vendorCodeOption so the dropdown shows the vendor code
  const vendorTypeId = formData.vendorTypeId ?? formData.vendor_type_id;
  useEffect(() => {
    if (!setFieldValue || vendorTypeId == null || vendorTypeId === "") return;
    if (vendorComboOptions.length === 0) return;
    const match =
      vendorComboOptions.find(
        (opt) =>
          (opt.id ?? opt.vendorTypeId ?? opt.vendor_type_id) == vendorTypeId,
      ) ?? null;
    if (match) {
      setFieldValue("vendorCodeOption", match);
      setFieldValue("vendorTypeCode", match.code ?? "");
    }
  }, [vendorComboOptions, vendorTypeId, setFieldValue]);

  const [showSecondaryContact, setShowSecondaryContact] = useState(
    Boolean(
      formData.secondaryContactName ||
      formData.secondaryContactDesignation ||
      formData.secondaryContactNo ||
      formData.secondaryContactEmail,
    ),
  );
  const [secondaryContactSlots, setSecondaryContactSlots] = useState(() => {
    const has1 = Boolean(
      formData.secondaryContactName ||
      formData.secondaryContactDesignation ||
      formData.secondaryContactNo ||
      formData.secondaryContactEmail,
    );
    const has2 = Boolean(
      formData.secondaryContactName2 ||
      formData.secondaryContactDesignation2 ||
      formData.secondaryContactNo2 ||
      formData.secondaryContactEmail2,
    );
    const has3 = Boolean(
      formData.secondaryContactName3 ||
      formData.secondaryContactDesignation3 ||
      formData.secondaryContactNo3 ||
      formData.secondaryContactEmail3,
    );
    const any = has1 || has2 || has3;
    return any ? [has1, has2, has3] : [true, false, false];
  });

  const handleAddPrimary = () => {
    setShowSecondaryContact(true);
  };

  const handleAddMoreSecondary = () => {
    setSecondaryContactSlots((prev) => {
      const idx = prev.findIndex((v) => !v);
      if (idx === -1) return prev;
      const next = [...prev];
      next[idx] = true;
      return next;
    });
  };

  const handleRemoveSecondary = (slotIndex) => {
    const bases = [
      "secondaryContactName",
      "secondaryContactDesignation",
      "secondaryContactNo",
      "secondaryContactEmail",
    ];
    bases.forEach((base) => {
      const name = slotIndex === 0 ? base : `${base}${slotIndex + 1}`;
      setFieldValue?.(name, "");
    });
    setSecondaryContactSlots((prev) => {
      const next = [...prev];
      next[slotIndex] = false;
      return next;
    });
  };

  const getSecondaryFieldName = (base, index) =>
    index === 0 ? base : `${base}${index + 1}`;

  const secondaryContactVisibleCount =
    secondaryContactSlots.filter(Boolean).length;
  const canAddMoreSecondary = secondaryContactVisibleCount < 2;
  const [isPrimarySameAsOwner, setIsPrimarySameAsOwner] = useState(false);

  useEffect(() => {
    if (!isPrimarySameAsOwner) return;
    setFieldValue?.("primaryContactName", formData.ownerName || "");
    setFieldValue?.("primaryContactNo", formData.ownerContactNo || "");
    setFieldValue?.("primaryContactEmail", formData.ownerEmail || "");
  }, [
    isPrimarySameAsOwner,
    formData.ownerName,
    formData.ownerContactNo,
    formData.ownerEmail,
    setFieldValue,
  ]);

  const handlePrimarySameAsOwnerChange = (event) => {
    const checked = event.target.checked;
    setIsPrimarySameAsOwner(checked);
    if (!checked) return;
    setFieldValue?.("primaryContactName", formData.ownerName || "");
    setFieldValue?.("primaryContactNo", formData.ownerContactNo || "");
    setFieldValue?.("primaryContactEmail", formData.ownerEmail || "");
  };

  return (
    <Box>
      {/* {fieldsEnabled && !isEdit && (
        <SectionCard title="Send Invite">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="sendInvite"
                    checked={Boolean(formData.sendInvite)}
                    onChange={(e) =>
                      setFieldValue?.("sendInvite", e.target.checked)
                    }
                    color="primary"
                  />
                }
                label="Send invite to owner (makes Owner Name, Contact No and E-mail mandatory)"
              />
            </Grid>
          </Grid>
        </SectionCard>
      )} */}

      <SectionCard title="Company Details">
        <Grid container spacing={2}>
          {/* Company Name */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Company Name"
              name="companyName"
              value={formData.companyName || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyName")}
              helperText={
                fieldHelper("companyName") ||
                "Name should match GST Registration, PAN, Cheque Leaf; if partnership need GOVT ID Proof"
              }
            />
          </Grid>

          {/* Shareholding Status — vendor: disabled radios (value set at invite) */}
          <Grid item xs={12}>
            <FormControl
              component="fieldset"
              error={!isVendorUser && fieldError("shareholdingStatus")}
              required={!isVendorUser}
              disabled={isVendorUser}
            >
              <FormLabel component="legend">Shareholding Status</FormLabel>
              <RadioGroup
                row
                name="shareholdingStatus"
                value={shareholdingStatusValue}
                onChange={
                  isVendorUser
                    ? undefined
                    : (e) =>
                        handleShareholdingStatusChange(e.target.value)
                }
              >
                {categoryOptions.map((opt) => (
                  <FormControlLabel
                    key={opt.value}
                    value={opt.value}
                    control={<Radio />}
                    label={opt.label}
                    disabled={isVendorUser}
                  />
                ))}
              </RadioGroup>
              {!isVendorUser && fieldHelper("shareholdingStatus") && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  {fieldHelper("shareholdingStatus")}
                </Typography>
              )}
            </FormControl>
          </Grid>
          {isShareholdingStatusOtherSelected && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Other - Description"
                name="shareholdingStatusOtherRemarks"
                value={formData.shareholdingStatusOtherRemarks || ""}
                onChange={onFieldChange}
                size="small"
                placeholder="Please describe"
                error={fieldError("shareholdingStatusOtherRemarks")}
                helperText={fieldHelper("shareholdingStatusOtherRemarks")}
                disabled={isVendorUser}
              />
            </Grid>
          )}
 {!isVendorUser && (
             <Grid item xs={12} sm={6}>
            <Autocomplete
              className={classes.customAutocompleteInput}
              options={vendorComboOptions}
              getOptionLabel={(option) => {
                if (typeof option === "string") return option;
                const code = option.code ?? "";
                const name = option.name ?? "";
                // return name ? `${code}` : code || "";
                return name || code;
              }}
     
              isOptionEqualToValue={(option, value) =>
                (option?.id ??
                  option?.vendorTypeId ??
                  option?.vendor_type_id) ==
                (value?.id ?? value?.vendorTypeId ?? value?.vendor_type_id)
              }
              value={formData.vendorCodeOption ?? null}
              onChange={(event, value) => {
                if (setFieldValue) {
                  const id = value
                    ? (value.id ?? value.vendorTypeId ?? value.vendor_type_id)
                    : null;
                  const code = value ? (value.code ?? "") : "";
                  setFieldValue("vendorCodeOption", value);
                  setFieldValue("vendorTypeId", id);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Vendor Type" variant="outlined" />
              )}
              size="small"
            />
          </Grid>
 )}
        
          {/* Nature of Business */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              multiline
              rows={1}
              label='Nature of Business with "MODENIK LIFESTYLE PRIVATE LIMITED"'
              name="natureOfBusiness"
              value={formData.natureOfBusiness || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("natureOfBusiness")}
              helperText={fieldHelper("natureOfBusiness")}
            />
          </Grid>

          {/* Company Address */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Company Address
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Street / Door No"
              name="companyStreetDoorNo"
              value={formData.companyStreetDoorNo || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyStreetDoorNo")}
              helperText={fieldHelper("companyStreetDoorNo")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Address Line 1"
              name="companyAddressLine1"
              value={formData.companyAddressLine1 || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyAddressLine1")}
              helperText={
                fieldHelper("companyAddressLine1") ||
                "Should match GST registration, Invoices, DCs etc"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Address Line 2"
              name="companyAddressLine2"
              value={formData.companyAddressLine2 || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyAddressLine2")}
              helperText={fieldHelper("companyAddressLine2")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Address Line 3"
              name="companyAddressLine3"
              value={formData.companyAddressLine3 || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyAddressLine3")}
              helperText={fieldHelper("companyAddressLine3")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Address Line 4"
              name="companyAddressLine4"
              value={formData.companyAddressLine4 || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyAddressLine4")}
              helperText={fieldHelper("companyAddressLine4")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Address Line 5"
              name="companyAddressLine5"
              value={formData.companyAddressLine5 || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyAddressLine5")}
              helperText={fieldHelper("companyAddressLine5")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Postal Code"
              required
              name="companyPostalCode"
              value={formData.companyPostalCode || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyPostalCode")}
              helperText={fieldHelper("companyPostalCode")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="City"
              required
              name="companyCity"
              value={formData.companyCity || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyCity")}
              helperText={fieldHelper("companyCity")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="State (Region)"
              required
              name="companyStateRegion"
              value={formData.companyStateRegion || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyStateRegion")}
              helperText={fieldHelper("companyStateRegion")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Country"
              name="companyCountry"
              value={formData.companyCountry || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("companyCountry")}
              helperText={fieldHelper("companyCountry")}
              disabled
            />
          </Grid>

          {/* Year of Establishment */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Year of Establishment"
              name="yearOfEstablishment"
              value={formData.yearOfEstablishment || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("yearOfEstablishment")}
              helperText={fieldHelper("yearOfEstablishment")}
            />
          </Grid>

        </Grid>
      </SectionCard>
      <SectionCard title="Owner details">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Name"
              name="ownerName"
              value={formData.ownerName || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("ownerName")}
              helperText={fieldHelper("ownerName")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Fathers Name"
              name="ownerFathersName"
              value={formData.ownerFathersName || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("ownerFathersName")}
              helperText={fieldHelper("ownerFathersName")}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="Contact Number"
              name="ownerContactNo"
              value={formData.ownerContactNo || ""}
              onChange={(e) => {
                setFieldValue?.("isOwnerContactNoAlreadyExists", "N");
                onFieldChange(e);
              }}
              onBlur={onOwnerContactBlur}
              size="small"
              error={fieldError("ownerContactNo")}
              helperText={fieldHelper("ownerContactNo")}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: 10,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              required
              label="E-mail ID"
              name="ownerEmail"
              type="email"
              value={formData.ownerEmail || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("ownerEmail")}
              helperText={fieldHelper("ownerEmail")}
              disabled={isVendorUser}
              
            />
          </Grid>
        </Grid>
      </SectionCard>
      <SectionCard title="Partner Details (if applicable)">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="partnerName"
              value={formData.partnerName || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("partnerName")}
              helperText={fieldHelper("partnerName")}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Contact Number"
              name="partnerContactNo"
              value={formData.partnerContactNo || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("partnerContactNo")}
              helperText={fieldHelper("partnerContactNo")}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="E-mail ID"
              name="partnerEmail"
              type="email"
              value={formData.partnerEmail || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("partnerEmail")}
              helperText={fieldHelper("partnerEmail")}
            />
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard title="Primary Contact Information">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isPrimarySameAsOwner}
                  onChange={handlePrimarySameAsOwnerChange}
                  color="primary"
                />
              }
              label="Same as Owner Details"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="primaryContactName"
              required
              value={formData.primaryContactName || ""}
              onChange={onFieldChange}
              size="small"
              InputProps={{ readOnly: isPrimarySameAsOwner }}
              error={fieldError("primaryContactName")}
              helperText={fieldHelper("primaryContactName")}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Designation"
              name="primaryContactDesignation"
              required
              value={formData.primaryContactDesignation || ""}
              onChange={onFieldChange}
              size="small"
              error={fieldError("primaryContactDesignation")}
              helperText={fieldHelper("primaryContactDesignation")}
            />
          </Grid>

          <Grid item xs={12} sm={5}>
            <TextField
              fullWidth
              required
              label="Contact Number"
              name="primaryContactNo"
              value={formData.primaryContactNo || ""}
              onChange={onFieldChange}
              size="small"
              InputProps={{ readOnly: isPrimarySameAsOwner }}
              error={fieldError("primaryContactNo")}
              helperText={fieldHelper("primaryContactNo")}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              fullWidth
              required
              label="E-mail ID"
              name="primaryContactEmail"
              type="email"
              value={formData.primaryContactEmail || ""}
              onChange={onFieldChange}
              size="small"
              InputProps={{ readOnly: isPrimarySameAsOwner }}
              error={fieldError("primaryContactEmail")}
              helperText={fieldHelper("primaryContactEmail")}
            />
          </Grid>
          <Grid item xs={12} sm={2} mt={0.5}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={handleAddPrimary}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </SectionCard>

      {showSecondaryContact && (
        <SectionCard title="Secondary Contact Information">
          <Grid container spacing={2}>
            {secondaryContactSlots.map(
              (visible, index) =>
                visible && (
                  <React.Fragment key={index}>
                    {secondaryContactVisibleCount > 1 && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        <Typography variant="subtitle2" color="text.secondary">
                          Contact {index + 1}
                        </Typography>
                        {index >= 1 && (
                          <Button
                            size="small"
                            color="error"
                            variant="outlined"
                            onClick={() => handleRemoveSecondary(index)}
                          >
                            Remove
                          </Button>
                        )}
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Name"
                        name={getSecondaryFieldName(
                          "secondaryContactName",
                          index,
                        )}
                        value={
                          formData[
                            getSecondaryFieldName("secondaryContactName", index)
                          ] || ""
                        }
                        onChange={onFieldChange}
                        size="small"
                        error={fieldError(
                          getSecondaryFieldName("secondaryContactName", index),
                        )}
                        helperText={fieldHelper(
                          getSecondaryFieldName("secondaryContactName", index),
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Designation"
                        name={getSecondaryFieldName(
                          "secondaryContactDesignation",
                          index,
                        )}
                        value={
                          formData[
                            getSecondaryFieldName(
                              "secondaryContactDesignation",
                              index,
                            )
                          ] || ""
                        }
                        onChange={onFieldChange}
                        size="small"
                        error={fieldError(
                          getSecondaryFieldName(
                            "secondaryContactDesignation",
                            index,
                          ),
                        )}
                        helperText={fieldHelper(
                          getSecondaryFieldName(
                            "secondaryContactDesignation",
                            index,
                          ),
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Contact Number"
                        name={getSecondaryFieldName(
                          "secondaryContactNo",
                          index,
                        )}
                        value={
                          formData[
                            getSecondaryFieldName("secondaryContactNo", index)
                          ] || ""
                        }
                        onChange={onFieldChange}
                        size="small"
                        error={fieldError(
                          getSecondaryFieldName("secondaryContactNo", index),
                        )}
                        helperText={fieldHelper(
                          getSecondaryFieldName("secondaryContactNo", index),
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="E-mail ID"
                        name={getSecondaryFieldName(
                          "secondaryContactEmail",
                          index,
                        )}
                        type="email"
                        value={
                          formData[
                            getSecondaryFieldName(
                              "secondaryContactEmail",
                              index,
                            )
                          ] || ""
                        }
                        onChange={onFieldChange}
                        size="small"
                        error={fieldError(
                          getSecondaryFieldName("secondaryContactEmail", index),
                        )}
                        helperText={fieldHelper(
                          getSecondaryFieldName("secondaryContactEmail", index),
                        )}
                      />
                    </Grid>
                  </React.Fragment>
                ),
            )}
            {canAddMoreSecondary && (
              <Grid item xs={12} sm={2} sx={{ mt: 0.5 }}>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={handleAddMoreSecondary}
                >
                  Add More
                </Button>
              </Grid>
            )}
          </Grid>
        </SectionCard>
      )}
    </Box>
  );
};

export default Step1CompanyDetails;
